import C from "../assets/c.png";
import CPP from "../assets/cpp.png";
import Java from "../assets/java.png";
import MySQL from "../assets/mysql.png";
import mongodb from "../assets/mongodb.png";
import nodejs from "../assets/nodejs.png";
import Expressjs from "../assets/Expressjs.png";
import react from "../assets/react.png";
import tailwind from "../assets/tailwind.png";
import bootstrap from "../assets/bootstrap.png";

export const languageIcons = [
  { key: "C", src: C, alt: "C programming language logo", className: "w-12 sm:w-16 sm:h-20 sm:hover:w-20 sm:hover:h-24" },
  { key: "Java", src: Java, alt: "Java programming language logo", className: "w-12 sm:w-16 sm:h-24 sm:hover:w-20 sm:hover:h-28" },
  { key: "C++", src: CPP, alt: "C++ programming language logo", className: "w-12 sm:w-16 sm:h-20 sm:hover:w-20 sm:hover:h-24" },
  { key: "MySQL", src: MySQL, alt: "MySQL database logo", className: "w-20 sm:w-20 sm:h-16 sm:hover:w-24 sm:hover:h-20" },
];

export const technologyIcons = [
  { key: "MongoDB", src: mongodb, alt: "MongoDB logo", className: "w-28 h-12 sm:w-36 sm:h-16 sm:hover:w-40 sm:hover:h-16 bg-slate-200 rounded-xl p-2" },
  { key: "Node.js", src: nodejs, alt: "Node.js logo", className: "w-24 h-16 hover:w-28 hover:h-16 bg-slate-200 rounded-xl p-2" },
  { key: "Express.js", src: Expressjs, alt: "Express.js logo", className: "w-28 h-12 sm:w-36 sm:h-16 sm:hover:w-40 sm:hover:h-16 bg-slate-200 rounded-xl p-2" },
  { key: "React", src: react, alt: "React logo", className: "w-16 h-14 hover:w-20 hover:h-16" },
];

export const frameworkIcons = [
  { key: "Tailwind CSS", src: tailwind, alt: "Tailwind CSS logo", className: "w-48 h-12 hover:w-52 hover:h-12 bg-slate-200 rounded-xl p-2" },
  { key: "Bootstrap", src: bootstrap, alt: "Bootstrap logo", className: "w-16 h-14 hover:w-20 hover:h-16" },
];

